<template>
  <vue-modal
    name="shareInStoreModal"
    :pivotY="0.25"
    height="auto"
    width="75%"
    :classes="['generic-modals', 'v--modal']"
    @opened="opened"
    @closed="closed"
    ref="vueModal">
    <div class="modals-share-in-store row">
      <div slot="top-right">
        <button class="close-button modals-share-in-store-form" @click="$modal.hide('shareInStoreModal')">
          <span class="icon-close"></span>
        </button>
      </div>
      <div v-show="showSpinner" class="modal-spinner-wrapper">
        <base-spinner></base-spinner>
      </div>
      <div class="columns modal-img-wrapper modals-share-in-store-wrapper large-6">
        <img :src="imgSrc" class="modals-share-in-store-wrapper-img text-center"/>
      </div>
      <div v-show="showFormView" class="columns large-6">
        <div class="modals-share-in-store-content">
          <h2 class="modals-share-in-store-header">{{ translations.shareInStoreHeader }}</h2>
          <form @submit="checkForm($event)" method="POST">
            <h4 class="subheader modals-share-in-store-subheader">{{ translations.shareInStoreSubHeader }}</h4>
            <input v-model="email" type="email" class="email" name="email" :placeholder="translations.shareInStorePHEmail" required/>
            <div class="modals-share-in-store-form">
              <h5>{{ translations.shareInStoreSize }}</h5>
              <select v-model="selectedSize" class="modals-share-in-store-select" name="configurator2-inStoreShareForm" required>
                <option value="">{{ translations.selectText }}</option>
                <option
                  v-for="(value, indexForSizes) in sizes.values"
                  :key="value"
                  :value="sizes.identifier[indexForSizes]">
                  {{ value }}
                </option>
              </select>
            </div>
            <button
              :class="['button primary modals-share-in-store-submit expand', { 'disabled' :  disableSubmitButton }]"
              :disabled="disableSubmitButton" type="submit"
            >
              {{ translations.shareInStoreSendIt }}
            </button>
          </form>
        </div>
      </div>
      <div v-show="!showFormView && !showSpinner" class="modals-share-in-store-success columns large-6">
        <div class="large-6 columns">
            <h2 class="modals-share-in-store-header">{{ translations.shareInStoreHeader }}</h2>
            <div v-show="!showSuccessViewError" class="modals-share-in-store-message">
              <h4 class="subheader modals-share-in-store-subheader">{{ translations.shareInStoreSubHeader }}</h4>
              <h5 class="modals-share-in-store-success-message">{{ translations.shareInStoreSuccess }}</h5>
            </div>
            <div v-show="showSuccessViewError">
              <h2 class="text-center modals-share-in-store-header">{{ translations.shareInStoreError }}</h2>
              <p class="text-center">
                <strong>{{ translations.shareInStoreErrorEmail }}</strong>
              </p>
            </div>
          </div>
        </div>
    </div>
  </vue-modal>
</template>

<script>
import { getRegion, getLocale, getCaid, getConfigurationObject } from "@/data/regionInfo";
import baseSpinner from '@/components/Spinner';

export default {
  name: "ShareInStoreModal",
  components: {
      baseSpinner
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    sizes() {
      return this.$store.state.utils.audienceSizes;
    },
    disableSubmitButton() {
      return this.selectedSize === "" || this.blockSubmitButton;
    }
  },
  data() {
    return {
      showSpinner: true,
      showFormView: false,
      showSuccessViewError: false,
      imgSrc: null,
      selectedSize: "",
      email: "",
      blockSubmitButton: false
    }
  },
  methods: {
    getProductImages() {
      const featuredView = this.pdm.product_images.featured_views.sharing || {
        "view": "left",
        "size": "md"
      };
      this.$store.dispatch("recipe/SAVE_RECIPE", {
        recipe: this.recipe_v2,
        requestParams: { locale: getLocale() }
      }).then(()=>{
        return this.$store.dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID", {
          recipe_id: this.recipe_v2.recipe_id,
          locale: getLocale(),
          ...featuredView
        })
      }).then((response)=> {
        this.imgSrc = response[featuredView.view + "_view"][featuredView.size];
        this.showSpinner = false;
        this.showFormView = true;
      }).catch(err => {
        console.error(err);
        if (err === 'InvalidRecipeError') this.$modal.hide('shareInStoreModal');
      });
    },
    checkForm($event){
      $event.preventDefault();
      this.blockSubmitButton = true;
      const data = {
        email: this.email,
        recipe_id: this.recipe_v2.recipe_id
      };

      this.showSpinner = true;
      this.getPartNumber().then(({ partNumber }) => {
        data.sku = partNumber;
        return this.$store.dispatch("utils/SHARE_IN_STORE", data);
      }).then((response)=> {
        this.showSpinner = false;
        this.showFormView = false;
        this.blockSubmitButton = false;
      }).catch(()=> {
        this.showSuccessViewError = true;
        this.showSpinner = false;
        this.showFormView = false;
        this.blockSubmitButton = false;
      });
    },
    getSku(recipe_id, size) {
      return new Promise((resolve, reject) => {
          this.$store.dispatch("buyPanel/GET_SKU", {
              recipe_id: recipe_id,
              locale: getLocale(),
              size: size,
          }).then(data => {
              data.recipe_id = recipe_id;
              resolve(data);
          }).catch(err => {
              console.error("Error getting sku:", err);
              reject(err);
          });
      });
    },
    getPartNumber() {
      return this.getSku(this.recipe_v2.recipe_id, this.selectedSize).then(data => {
        let product = {};
        product.extRecipeId = data.recipe_id;
        product.partNumber = data.sku;
        product.quantity = 1;
        return product;
      });
    },
    opened() {
      this.getProductImages();
    },
    closed() {
      this.showSpinner = true;
      this.showFormView = false;
      this.showSuccessViewError = false;
      this.imgSrc = null;
      this.selectedSize = "";
      this.email = "";
      this.blockSubmitButton = false;
    }
  }
};
</script>
